import { IncrementalSearchResultList } from "./IncrementalSearchResultList";

import { useFolderSearchResult } from "~/client/components/search/hooks/useFolderSearchResult";
import { useMemberSearchResult } from "~/client/components/search/hooks/useMemberSearchResult";
import { useNoteAndCommentSearchResult } from "~/client/components/search/hooks/useNoteAndCommentSearchResult";
import { useSavedSearchFilterSets } from "~/client/components/search/hooks/useSavedSearchFilterSets";
import { membersPath, searchPath } from "~/client/generated/routes";

interface Props {
  query: string;
  onSearch: () => void;
}
export const IncrementalSearchResultListContainer: React.FC<Props> = ({ query, onSearch }) => {
  const noteAndComment = useNoteAndCommentSearchResult(query);

  const folder = useFolderSearchResult(query);
  const handleViewAllFolders = () => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    location.assign(searchPath({ "resource_types[]": "Folder", query }));
  };

  const member = useMemberSearchResult(query);
  const handleViewAllMembers = () => {
    location.assign(membersPath({ query }));
  };

  const filterSets = useSavedSearchFilterSets();

  return (
    <IncrementalSearchResultList
      query={query}
      noteAndComment={{
        items: noteAndComment.items,
        onViewAll: onSearch!,
        isLoading: noteAndComment.isLoading,
      }}
      folder={{
        items: folder.items,
        onViewAll: handleViewAllFolders,
        isLoading: folder.isLoading,
      }}
      member={{ items: member.items, onViewAll: handleViewAllMembers, isLoading: member.isLoading }}
      filterSets={{
        items: filterSets.items,
        isLoading: filterSets.isLoading,
        handleDelete: filterSets.handleDelete,
      }}
    />
  );
};
